<!-- SPDX-License-Identifier: LicenseRef-MMS-WIRE -->
<!-- Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd -->

<footer class="legal-footer">
  <span class="legal-footer__notice">{{ notice }}</span>
  <nav class="legal-footer__links" aria-label="Legal">
    <a class="legal-footer__link" [href]="gtcPath" target="_blank" rel="noopener">Terms and conditions</a>
    <span class="legal-footer__sep" aria-hidden="true">|</span>
    <a class="legal-footer__link" [href]="licencePath" target="_blank" rel="noopener">Licence</a>
    <span class="legal-footer__sep" aria-hidden="true">|</span>
    <button class="legal-footer__link legal-footer__about" type="button" (click)="openAbout()">About WIRE</button>
  </nav>
</footer>
